import { combineReducers } from 'redux'

import affiliations from './affiliations'
import autoIntegrate from './autoIntegrate'
import application from './application'
import customers from './customers'
import notifications from './notifications'
import shopOrders from './shopOrders'
import shopOrderFilters from './shopOrderFilters'
import shopOrderStates from './shopOrderStates'
import orderIssues from './orderIssues'
import users from './users'
import versions from './versions'

const combinedReducer = combineReducers({
  /* NOTE: Add other reducers here */
  affiliations,
  autoIntegrate,
  application,
  customers,
  notifications,
  shopOrders,
  shopOrderFilters,
  shopOrderStates,
  orderIssues,
  users,
  versions
})

export default combinedReducer
